<template>

  <MassiveEmail
    :initEmail="initEmail"
    @hideModal="hideModal()" 
    @created="created()" />

</template>

<script>
import MassiveEmail from '@/components/MassiveEmail/MassiveEmail'

export default {
  name: 'JobActionMassEmail',
  components: {
    MassiveEmail
  },
  data () {
    return {
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    candidates () {
      return this.$store.getters.getCandidateSelected
    },
    initEmail () {
      return {
        candidates: this.candidates,
        job_id: this.job._id
      }
    }
  },
  created () {
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    created () {
      this.hideModal()
      this.$store.dispatch('resetCandidateSelected')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobMassiveAction/JobMassiveActionEmail.vue